import { render, staticRenderFns } from "./MenuListFilterSwitcher.vue?vue&type=template&id=4e354bda&"
import script from "./MenuListFilterSwitcher.vue?vue&type=script&lang=js&"
export * from "./MenuListFilterSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports